import { NavLink } from "react-router-dom";
import { Bookmark, Film, Home, Search, Sparkles, User } from "lucide-react";
import { useGuest } from "@/context/GuestContext";
import { useCreatorOn } from "@/lib/platform";

const TABS = [
  { label: "Home", to: "/", icon: Home, end: true },
  { label: "Watch", to: "/movies", icon: Film },
  { label: "Create", to: "/create", icon: Sparkles, gated: "create" },
  { label: "Library", to: "/library", icon: Bookmark, gated: "library" },
  { label: "Profile", to: "/account", icon: User, gated: "account" },
];

const SEARCH_TAB = { label: "Search", to: "/search", icon: Search };

export const MobileNav = () => {
  const { isGuest, openAuth } = useGuest();
  const tabs = useCreatorOn() ? TABS : TABS.map((t) => (t.gated === "create" ? SEARCH_TAB : t));
  return (
  <nav
    data-testid="mobile-bottom-nav"
    className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-[#050505]/85 backdrop-blur-xl"
    style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
  >
    <div className="gold-hairline" />
    <div className="grid grid-cols-5">
      {tabs.map(({ label, to, icon: Icon, end, gated }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          onClick={(e) => { if (isGuest && gated) { e.preventDefault(); openAuth({ reason: gated }); } }}
          data-testid={`bottom-nav-${label.toLowerCase()}`}
          className={({ isActive }) => `relative flex h-[60px] flex-col items-center justify-center gap-1 text-[0.72rem] font-semibold tracking-wide transition-colors active:scale-95 ${isActive ? "text-[#FFD86A]" : "text-[#8B8B8B]"}`}
        >
          {({ isActive }) => (
            <>
              <span className={`absolute top-0 h-[2px] w-8 rounded-full transition-opacity ${isActive ? "opacity-100 bg-gradient-to-r from-[#D4AF37] to-[#FFD86A] shadow-[0_0_12px_rgba(255,216,106,0.9)]" : "opacity-0"}`} />
              <Icon className={`h-[22px] w-[22px] ${isActive ? "drop-shadow-[0_0_8px_rgba(255,216,106,0.6)]" : ""}`} strokeWidth={isActive ? 2.1 : 1.7} />
              {label}
            </>
          )}
        </NavLink>
      ))}
    </div>
  </nav>
  );
};
